// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"loader_mainDiv__2K2HE","innerDiv":"loader_innerDiv__2o4It"};